const redirectOptions = [
  {
    from: '/home/dashboard',
    to: '/welcome',
  },
  {
    from: '/home/chatbot',
    to: '/bots',
  },
  {
    from: '/flows',
    to: '/bots',
  },
  {
    from: '/signin',
    to: '/',
  },
  {
    from: '/notifications',
    to: '/attraction',
  },
  {
    from: '/campaign',
    to: '/attraction',
  },
  {
    from: '/sales',
    to: '/sales-chat/inbox',
  },
  {
    from: '/service',
    to: '/service/chat',
    exact: true,
  },
  {
    from: '/chatbot',
    to: '/chatbot/list',
    exact: true,
  },
  {
    from: '/broadcast',
    to: '/broadcast/homepage',
    exact: true,
  },
  {
    from: '/report',
    to: '/analysis/contacts-report',
    exact: true,
  },
]

// exact: only the bare route (ignoring a trailing slash) redirects, so real
// sub-routes like /service/tickets or /broadcast/sms are left untouched
const matchesRoute = (currentRoute, option) => {
  if (option.exact) {
    return currentRoute === option.from || currentRoute === `${option.from}/`
  }

  return currentRoute === option.from || currentRoute.startsWith(`${option.from}/`)
}

// eslint-disable-next-line arrow-body-style
export default ({ navigateToUrl }) => {
  return async () => {
    const currentRoute = window.location.pathname

    const redirect = redirectOptions.find((option) => matchesRoute(currentRoute, option))

    if (redirect) {
      navigateToUrl(redirect.to)
    }
  }
}
